// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.season-manager-wrapper {
    max-width: 560px;
    margin: 0 auto;
    padding: 1.5rem 1rem;
}

.season-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,.08);
    padding: 2rem;
}

.season-header {
    text-align: center;
    margin-bottom: 1.5rem;
}

.season-header i {
    font-size: 2rem;
    color: #f5a623;
    margin-bottom: .5rem;
    display: block;
}

.season-header h1 {
    font-size: 1.4rem;
    margin: 0 0 .4rem;
    color: #1a1a2e;
}

.season-header p {
    color: #666;
    font-size: .9rem;
    margin: 0;
}

.season-error {
    background: #fff0f0;
    border: 1px solid #fca5a5;
    border-radius: 8px;
    color: #b91c1c;
    padding: .75rem 1rem;
    margin-bottom: 1rem;
    font-size: .9rem;
}

.season-form {
    display: flex;
    gap: .75rem;
    margin-bottom: 1.5rem;
}

.season-input {
    flex: 1;
    padding: .65rem 1rem;
    border: 1.5px solid #d1d5db;
    border-radius: 8px;
    font-size: 1rem;
    outline: none;
    transition: border-color .2s;
}

.season-input:focus {
    border-color: #f5a623;
}

.btn-add-season {
    background: #f5a623;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: .65rem 1.2rem;
    font-size: .95rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: .4rem;
    transition: background .2s;
}

.btn-add-season:hover {
    background: #d48c1a;
}

.season-loading,
.season-empty {
    text-align: center;
    color: #999;
    padding: 1rem 0;
}

.season-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: .6rem;
}

.season-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: .8rem 1rem;
    background: #fafafa;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
}

.season-name {
    font-weight: 600;
    color: #1a1a2e;
    display: flex;
    align-items: center;
    gap: .5rem;
}

.season-name i {
    color: #f5a623;
}

.btn-delete-season {
    background: none;
    border: none;
    color: #dc2626;
    cursor: pointer;
    font-size: 1rem;
    padding: .3rem .5rem;
    border-radius: 6px;
    transition: background .2s;
}

.btn-delete-season:hover {
    background: #fee2e2;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SeasonManager.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;IACtC,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,OAAO;IACP,oBAAoB;IACpB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".season-manager-wrapper {\n    max-width: 560px;\n    margin: 0 auto;\n    padding: 1.5rem 1rem;\n}\n\n.season-card {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 2px 12px rgba(0,0,0,.08);\n    padding: 2rem;\n}\n\n.season-header {\n    text-align: center;\n    margin-bottom: 1.5rem;\n}\n\n.season-header i {\n    font-size: 2rem;\n    color: #f5a623;\n    margin-bottom: .5rem;\n    display: block;\n}\n\n.season-header h1 {\n    font-size: 1.4rem;\n    margin: 0 0 .4rem;\n    color: #1a1a2e;\n}\n\n.season-header p {\n    color: #666;\n    font-size: .9rem;\n    margin: 0;\n}\n\n.season-error {\n    background: #fff0f0;\n    border: 1px solid #fca5a5;\n    border-radius: 8px;\n    color: #b91c1c;\n    padding: .75rem 1rem;\n    margin-bottom: 1rem;\n    font-size: .9rem;\n}\n\n.season-form {\n    display: flex;\n    gap: .75rem;\n    margin-bottom: 1.5rem;\n}\n\n.season-input {\n    flex: 1;\n    padding: .65rem 1rem;\n    border: 1.5px solid #d1d5db;\n    border-radius: 8px;\n    font-size: 1rem;\n    outline: none;\n    transition: border-color .2s;\n}\n\n.season-input:focus {\n    border-color: #f5a623;\n}\n\n.btn-add-season {\n    background: #f5a623;\n    color: #fff;\n    border: none;\n    border-radius: 8px;\n    padding: .65rem 1.2rem;\n    font-size: .95rem;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: .4rem;\n    transition: background .2s;\n}\n\n.btn-add-season:hover {\n    background: #d48c1a;\n}\n\n.season-loading,\n.season-empty {\n    text-align: center;\n    color: #999;\n    padding: 1rem 0;\n}\n\n.season-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: .6rem;\n}\n\n.season-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: .8rem 1rem;\n    background: #fafafa;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n}\n\n.season-name {\n    font-weight: 600;\n    color: #1a1a2e;\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n}\n\n.season-name i {\n    color: #f5a623;\n}\n\n.btn-delete-season {\n    background: none;\n    border: none;\n    color: #dc2626;\n    cursor: pointer;\n    font-size: 1rem;\n    padding: .3rem .5rem;\n    border-radius: 6px;\n    transition: background .2s;\n}\n\n.btn-delete-season:hover {\n    background: #fee2e2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
